import styled from 'styled-components';
import { SkillsByName } from '../../services/skill';
import { TaskRewardProps } from '../../services/task';
import Icon from '../../ui/Icon';

interface Props {
    rewards: TaskRewardProps[]
}

export default function TaskExperience({ rewards = [] }: Props) {
    return (
        <Wrapper className="task-xp-container">
            {/* todo: change key */}
            {rewards.map(reward => <div className={`task-xp ${rewards.length > 1 && 'multiple'}`} key={`${reward.type}-${reward.xp}`}>
                <Icon className="task-xp-icon" icon={SkillsByName[reward.type].icon} size={30} title={SkillsByName[reward.type].name} />
                <div className="task-xp-text">+ {reward.xp.toFixed(1)}xp</div>
            </div>)}
        </Wrapper>
    )
}

const Wrapper = styled.div`
    grid-area: experience;
    display: flex;
    margin: 0 -4px;

    .task-xp {
        margin: 0 4px;
        background-color: ${props => props.theme.backgroundColor};
        border-radius: ${props => props.theme.borderRadius};
        flex-grow: 1;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;

        &.multiple {
            flex-direction: column;
        }
    }

    .task-xp-icon {
        padding: 2px 4px;
    }

    .task-xp-text {
        padding: 2px 4px;
        text-align: center;
        font-size: 12px;
        min-width: 40px;
        color: #eee;
    }
`